import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/authContext";
import { Link, useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaGoogle } from "react-icons/fa";
import logo from "../assets/Logo.png";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";
import { signOut } from "firebase/auth";
import PopupModal from "./PopupModal";

export function Login() {
  const emailRef = useRef(null);
  const {
    GuardarEnLocal,
    login,
    loginWithGoogle,
    resetPassword,
    Estado,
    sincronizarUsuarioYDispositivo,
  } = useAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState({ email: "", password: "" });

  const [popup, setPopup] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
  });

  const traducirError = (error) => {
    switch (error.code) {
      case "auth/invalid-email":
        return "⚠️ El email no es válido, revisa el formato.";
      case "auth/user-not-found":
        return "❌ No encontramos ninguna cuenta con ese correo.";
      case "auth/wrong-password":
        return "🔑 La contraseña es incorrecta, vuelve a intentarlo.";
      case "auth/too-many-requests":
        return "🚫 Demasiados intentos fallidos, espera un momento antes de volver a intentarlo.";
      case "auth/missing-email":
        return "📧 Por favor, escribe tu correo antes de continuar.";
      case "auth/popup-closed-by-user":
        return "❌ Cancelaste el inicio de sesión con Google.";
      default:
        return "⚠️ Algo salió mal al iniciar sesión. Revisa tu email y contraseña";
    }
  };

  const frases = [
    "Pedalea con fuerza, cada vuelta cuenta 💪",
    "Tu mejor versión comienza ahora 🚀",
    "Hoy es un buen día para superar tus límites 🔥",
  ];
  const frase = frases[Math.floor(Math.random() * frases.length)];

  useEffect(() => {
    const timer = setTimeout(() => {
      emailRef.current?.focus();
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value });
  };

  // ------------------ LOGIN CON EMAIL ------------------
const handleSubmit = async (e) => {
  e.preventDefault();
  setPopup({ show: false, type: "info", title: "", message: "" });

  try {
    const userCredential = await login(user.email, user.password);
    const uid = userCredential.user.uid;

    // 🔒 validar que existe en colección "usuarios"
    const userRef = doc(db, "usuarios", uid);
    const snap = await getDoc(userRef);

    if (!snap.exists()) {
      await signOut(auth);
      throw new Error("🚫 Tu cuenta no está registrada como usuario válido.");
    }

    // 👉 usar siempre el nombre de Firestore si existe
    const nombre = snap.data().nombre || userCredential.user.displayName || "Usuario";

    await sincronizarUsuarioYDispositivo(uid, nombre, user.email);
    await GuardarEnLocal(uid);
    //await Estado(uid);

    localStorage.setItem("PuntosSesion", 0);
    localStorage.setItem("PuntosTotales", 0);

    navigate("/Comprobacion");
  } catch (error) {
    console.error("❌ Error login:", error);
    setPopup({
      show: true,
      type: "error",
      title: "Error de login",
      message: traducirError(error),
    });
  }
};


// ------------------ LOGIN CON GOOGLE ------------------
const handleGoogleSignin = async () => {
  try {
    const userCredential = await loginWithGoogle();
    const uid = userCredential.user.uid;
    const email = userCredential.user.email;

    // 👇 Recargar datos del usuario para asegurar que displayName esté disponible
    await auth.currentUser.reload();
    const displayName = auth.currentUser.displayName || "Usuario";

    console.log("✅ Google Sign-In → displayName tras reload:", displayName);

    // 🔄 Aquí sí usamos tu lógica de los 3 casos
    await sincronizarUsuarioYDispositivo(uid, displayName, email);

    // Guardar en local y estado
    await GuardarEnLocal(uid);
    localStorage.setItem("PuntosSesion", 0);
    localStorage.setItem("PuntosTotales", 0);

    // ✅ Redirigir
    navigate("/Comprobacion");
  } catch (error) {
    console.error("❌ Error login con Google:", error);
    setPopup({
      show: true,
      type: "error",
      title: "Error de login con Google",
      message: traducirError(error),
    });
  }
};

  // ------------------ RESET PASSWORD ------------------
  const handleResetPassword = async () => {
    if (!user.email)
      return setPopup({
        show: true,
        type: "error",
        title: "Error",
        message: "Por favor, ingresa tu email",
      });

    try {
      const actionCodeSettings = {
        url: "https://rpm.coachcycling.com/reset-password",
        handleCodeInApp: true,
      };

      await resetPassword(user.email, actionCodeSettings);
      setPopup({
        show: true,
        type: "success",
        title: "Email enviado",
        message: "✅ Te hemos enviado un e-mail con un link para resetear tu password",
      });
    } catch (error) {
      setPopup({
        show: true,
        type: "error",
        title: "Error",
        message: traducirError(error),
      });
    }
  };

  // ------------------ UI ------------------
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl p-8 w-[350px] text-center">
        <img src={logo} alt="Logo" className="mx-auto w-40" />

        <h1 className="text-2xl font-bold text-white mb-6">🚴‍♂️ Bienvenido</h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center bg-white/20 rounded-lg p-3">
            <FaUser className="text-white mr-3" />
            <input
              ref={emailRef}
              type="email"
              name="email"
              placeholder="tuemail@gmail.com"
              className="bg-transparent outline-none text-white w-full"
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex items-center bg-white/20 rounded-lg p-3">
            <FaLock className="text-white mr-3" />
            <input
              type="password"
              name="password"
              placeholder="******"
              className="bg-transparent outline-none text-white w-full"
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-xl font-semibold transition"
          >
            Entrar a la clase
          </button>
        </form>

        <button
          onClick={handleGoogleSignin}
          className="mt-4 flex items-center justify-center gap-2 w-full bg-white text-black py-3 rounded-xl shadow-md hover:bg-gray-100 transition"
        >
          <FaGoogle /> Iniciar sesión con Google
        </button>

        <div className="mt-4 flex justify-between text-sm text-gray-300">
          <a href="#!" onClick={handleResetPassword} className="hover:underline">
            ¿Olvidaste tu contraseña?
          </a>
          <Link to="/register" className="hover:underline">
            Regístrate
          </Link>
        </div>

        <p className="mt-6 text-sm text-gray-400">
          Al usar nuestra app aceptas la{" "}
          <a
            href="https://coachcycling.com/privacy-policy-2"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            política de privacidad
          </a>
        </p>

        <p className="mt-6 text-sm italic text-gray-200">{frase}</p>
      </div>

      {/* 🔹 Popup modal */}
      <PopupModal
        show={popup.show}
        onClose={() => setPopup({ ...popup, show: false })}
        type={popup.type}
        title={popup.title}
        message={popup.message}
      />
    </div>
  );
}

export default Login;
